import * as React from 'react';
import { PortalHeader } from 'components/PortalStructure';

export const MagazinePageLayout = (props: any) => {
	return (
		<>
			<PortalHeader magazineProps={props} />
			{props.children}
		</>
	);
};
